import { Component, Inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
    PwaPushNotificationInstanceToken,
    PwaPushNotificationInterface,
} from '../../interfaces/pwa-push-notification.interface';
import { finalize, take } from 'rxjs';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { PwaPushNotificationsLocalStorageService } from '../../services/pwa-push-notification/pwa-push-notifications.local-storage.service';

@Component({
    selector: 'pace-core-subscribe-push-notification-visual-guide',
    templateUrl: './subscribe-push-notifications-visual-guide.component.html',
    styleUrls: ['./subscribe-push-notifications-visual-guide.component.scss'],
    standalone: true,
})
export class SubscribePushNotificationVisualGuideComponent {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly modalInstance: BsModalRef,
        @Inject(PwaPushNotificationInstanceToken)
        private readonly pwaPushNotificationService: PwaPushNotificationInterface,
        private readonly pwaPushNotificationsLocalStorageService: PwaPushNotificationsLocalStorageService,
    ) {
        this.pwaPushNotificationsLocalStorageService
            .savePwaPushNotificationsUserSettingsAsync({
                isUserSubscribed: false,
                hasUserBeenOfferedToSubscribe: true,
            })
            .catch((error) => {
                this.log.error(this.constructor.name, 'Failed to save push notification user settings', error);
            });
    }

    public triggerPushNotificationSubscribe(): void {
        this.pwaPushNotificationService
            .pushNotificationSubscribe()
            .pipe(
                take(1),
                finalize(() => this.modalInstance.hide()),
            )
            .subscribe((success) => {
                if (success) {
                    this.log.debug('Subscribe Visual Guide: successfully subscribed to push notifications');
                } else {
                    this.log.warn('Subscribe Visual Guide: failed to subscribe to push notifications');
                }
            });
    }
}
